<template>
  <f7-page class="page-report-date has-footer">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Trở lại"></f7-nav-left>
      <f7-nav-title sliding>BÁO CÁO</f7-nav-title>
    </f7-navbar>
    <f7-block inset class="mt-0 mb-2">
      <f7-segmented raised>
        <f7-button :active="tab_active === 'today'" @click.prevent="tab_active = 'today'">
          NGÀY
        </f7-button>
        <f7-button :active="tab_active === 'this_week'" @click.prevent="tab_active = 'this_week'">
          TUẦN NÀY
        </f7-button>
        <f7-button :active="tab_active === 'last_week'" @click.prevent="tab_active = 'last_week'">
          TUẦN TRƯỚC
        </f7-button>
        <f7-button style="width: 120px" :active="tab_active === 'custom'" @click.prevent="tab_active = 'custom'">
          <f7-icon f7="calendar"></f7-icon>
        </f7-button>
      </f7-segmented>
    </f7-block>
    <f7-list inset inline-labels v-if="tab_active === 'today' || tab_active === 'custom'" class="mt-0 mb-1">
      <f7-list-input
        :label="tab_active === 'today' ? 'Ngày' : 'Từ ngày'"
        type="datepicker"
        :placeholder="tab_active === 'today' ? 'Chọn ngày' : 'Từ ngày'"
        :value="[this.report_date]"
        @calendar:change="(values) => report_date = values[0]"
        :calendar-params="{dateFormat: 'dd/mm/yyyy', locale: 'vi-VN', closeOnSelect: true, openIn: 'customModal'}">
        <f7-icon slot="media" ios="f7:calendar"></f7-icon>
      </f7-list-input>
      <f7-list-input
        label="Đến ngày"
        type="datepicker"
        v-if="tab_active === 'custom'"
        placeholder="Đến ngày"
        :value="[this.report_date_to]"
        @calendar:change="(values) => report_date_to = values[0]"
        :calendar-params="{dateFormat: 'dd/mm/yyyy', locale: 'vi-VN', closeOnSelect: true, openIn: 'customModal'}">
        <f7-icon slot="media" ios="f7:calendar"></f7-icon>
      </f7-list-input>
    </f7-list>
    <f7-block inset class="mt-0 mb-1">
      <f7-segmented raised strong>
        <f7-button :active="report_type_tab === 'summary'" @click.prevent="report_type_tab = 'summary', getReport(report_date, report_date_to)">
          TỔNG QUAN
        </f7-button>
        <f7-button :active="report_type_tab === 'region'" @click.prevent="report_type_tab = 'region'">
          MIỀN
        </f7-button>
        <f7-button :active="report_type_tab === 'detail'" @click.prevent="report_type_tab = 'detail'">
          CHI TIẾT
        </f7-button>
      </f7-segmented>
    </f7-block>
    <template v-if="report_type_tab === 'summary'">
      <div class="data-table card sm bordered">
        <table>
          <thead>
          <tr>
            <th colspan="5" class="text-align-center p-3">{{ report_date_string }}</th>
          </tr>
          <tr>
            <th></th>
            <th class="text-align-right" v-if="enabledRegion.indexOf('mn') >= 0">
              MN
            </th>
            <th class="text-align-right" v-if="enabledRegion.indexOf('mt') >= 0">
              MT
            </th>
            <th class="text-align-right" v-if="enabledRegion.indexOf('mb') >= 0">
              MB
            </th>
            <th class="text-align-right">T.CỘNG</th>
          </tr>
          </thead>
          <tbody v-if="report_result.length">
          <tr>
            <th colspan="5" class="text-bold">-- KHÁCH --</th>
          </tr>
          <tr v-for="(item, idx) in report_khach_customers" :key="`K_${idx}`">
            <td>{{ item.customer.fullname }}</td>
            <td class="text-align-right" v-if="enabledRegion.indexOf('mn') >= 0">
              {{ item.summary.mn.result_line_percent | numeral('0,0[.]0') }}
            </td>
            <td class="text-align-right" v-if="enabledRegion.indexOf('mt') >= 0">
              {{ item.summary.mt.result_line_percent | numeral('0,0[.]0') }}
            </td>
            <td class="text-align-right" v-if="enabledRegion.indexOf('mb') >= 0">
              {{ item.summary.mb.result_line_percent | numeral('0,0[.]0') }}
            </td>
            <td class="text-align-right">
              {{
                (item.summary.mn.result_line_percent + item.summary.mt.result_line_percent +
                  item.summary.mb.result_line_percent) | numeral('0,0[.]0')
              }}
            </td>
          </tr>
          <tr>
            <th colspan="5" class="text-bold">-- CHỦ --</th>
          </tr>
          <tr v-for="(item, idx) in report_chu_customers" :key="`C_${idx}`">
            <td>{{ item.customer.fullname }}</td>
            <td class="text-align-right" v-if="enabledRegion.indexOf('mn') >= 0">
              {{ item.summary.mn.result_line_percent | numeral('0,0[.]0') }}
            </td>
            <td class="text-align-right" v-if="enabledRegion.indexOf('mt') >= 0">
              {{ item.summary.mt.result_line_percent | numeral('0,0[.]0') }}
            </td>
            <td class="text-align-right" v-if="enabledRegion.indexOf('mb') >= 0">
              {{ item.summary.mb.result_line_percent | numeral('0,0[.]0') }}
            </td>
            <td class="text-align-right">
              {{
                (item.summary.mn.result_line_percent + item.summary.mt.result_line_percent +
                  item.summary.mb.result_line_percent) | numeral('0,0[.]0')
              }}
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <th class="text-bold">TỔNG CỘNG</th>
            <th class="text-align-right" v-if="enabledRegion.indexOf('mn') >= 0">
              {{ getSumProfitRegion('mn') | numeral('0,0[.]0') }}
            </th>
            <th class="text-align-right" v-if="enabledRegion.indexOf('mt') >= 0">
              {{ getSumProfitRegion('mt') | numeral('0,0[.]0') }}
            </th>
            <th class="text-align-right" v-if="enabledRegion.indexOf('mb') >= 0">
              {{ getSumProfitRegion('mb') | numeral('0,0[.]0') }}
            </th>
            <th class="text-align-right" :class="{'text-color-forestgreen': sum_profit >= 0, 'text-color-crimson': sum_profit < 0}">
              {{ sum_profit | numeral('0,0[.]0') }}
            </th>
          </tr>
          </tfoot>
        </table>
      </div>
    </template>
    <template v-else-if="report_type_tab === 'region'">
      <f7-block inset class="mt-0 mb-1" v-if="enabledRegion.length >= 2">
        <f7-segmented raised strong>
          <f7-button :active="report_region === 'mn'" @click.prevent="report_region = 'mn', report_play_style = 'default'" v-if="enabledRegion.indexOf('mn') >= 0">
            MN
          </f7-button>
          <f7-button :active="report_region === 'mt'" @click.prevent="report_region = 'mt', report_play_style = 'default'" v-if="enabledRegion.indexOf('mt') >= 0">
            MT
          </f7-button>
          <f7-button :active="report_region === 'mb'" @click.prevent="report_region = 'mb', report_play_style = 'default'" v-if="enabledRegion.indexOf('mb') >= 0">
            MB
          </f7-button>
        </f7-segmented>
      </f7-block>
      <f7-block inset class="mt-0 mb-2" v-if="enabledPlaystyle.length >= 2">
        <f7-segmented strong raised v-if="report_region === 'mn'">
          <f7-button :active="report_play_style === 'default'" @click.prevent="report_play_style = 'default', getDetailReport(report_date, report_date_to)" v-if="enabledPlaystyle.indexOf('default') >= 0">
            Sài Gòn
          </f7-button>
          <f7-button :active="report_play_style === 'mn_mtay'" @click.prevent="report_play_style = 'mn_mtay', getDetailReport(report_date, report_date_to)" v-if="enabledPlaystyle.indexOf('mn_mtay') >= 0">
            Miền Tây
          </f7-button>
          <f7-button :active="report_play_style === 'mn_buonme'" @click.prevent="report_play_style = 'mn_buonme', getDetailReport(report_date, report_date_to)" v-if="enabledPlaystyle.indexOf('mn_buonme') >= 0">
            Buôn Mê
          </f7-button>
        </f7-segmented>
        <f7-segmented strong raised v-else-if="report_region === 'mt'">
          <f7-button :active="report_play_style === 'default'" @click.prevent="report_play_style = 'default', getDetailReport(report_date, report_date_to)" v-if="enabledPlaystyle.indexOf('default') >= 0">
            Sài Gòn
          </f7-button>
          <f7-button :active="report_play_style === 'mt_mtay'" @click.prevent="report_play_style = 'mt_mtay', getDetailReport(report_date, report_date_to)" v-if="enabledPlaystyle.indexOf('mt_mtay') >= 0">
            Miền Tây
          </f7-button>
          <f7-button :active="report_play_style === 'mt_buonme'" @click.prevent="report_play_style = 'mt_buonme', getDetailReport(report_date, report_date_to)" v-if="enabledPlaystyle.indexOf('mt_buonme') >= 0">
            Buôn Mê
          </f7-button>
        </f7-segmented>
        <f7-segmented strong raised v-else-if="report_region === 'mb'">
          <f7-button :active="report_play_style === 'default'" @click.prevent="report_play_style = 'default', getDetailReport(report_date, report_date_to)" v-if="enabledPlaystyle.indexOf('default') >= 0">
            Sài Gòn
          </f7-button>
          <f7-button :active="report_play_style === 'mb_mtay'" @click.prevent="report_play_style = 'mb_mtay', getDetailReport(report_date, report_date_to)" v-if="enabledPlaystyle.indexOf('mb_mtay') >= 0">
            Miền Tây
          </f7-button>
          <f7-button :active="report_play_style === 'mb_buonme'" @click.prevent="report_play_style = 'mb_buonme', getDetailReport(report_date, report_date_to)" v-if="enabledPlaystyle.indexOf('mb_buonme') >= 0">
            Buôn Mê
          </f7-button>
          <f7-button :active="report_play_style === 'mb_ngan'" @click.prevent="report_play_style = 'mb_ngan', getDetailReport(report_date, report_date_to)" v-if="enabledPlaystyle.indexOf('mb_ngan') >= 0">
            Nghệ An
          </f7-button>
          <f7-button :active="report_play_style === 'mb_hanoi'" @click.prevent="report_play_style = 'mb_hanoi', getDetailReport(report_date, report_date_to)" v-if="enabledPlaystyle.indexOf('mb_hanoi') >= 0">
            Hà Nội
          </f7-button>
        </f7-segmented>
      </f7-block>
      <template v-if="!_.isEmpty(region_report_result)">
        <message-region-summary :item="region_report_result.user" :customer-type="1" :region="report_region" :play-style="report_play_style" :draw-date="report_date_string"></message-region-summary>
        <message-region-summary :item="region_report_result.leader" :customer-type="2" :region="report_region" :play-style="report_play_style" :draw-date="report_date_string"></message-region-summary>
      </template>
    </template>
    <template v-else-if="report_type_tab === 'detail'">
      <f7-block inset class="mt-0 mb-1" v-if="enabledRegion.length >= 2">
        <f7-segmented raised strong>
          <f7-button :active="report_region === 'mn'" @click.prevent="report_region = 'mn', report_play_style = 'default'" v-if="enabledRegion.indexOf('mn') >= 0">
            MN
          </f7-button>
          <f7-button :active="report_region === 'mt'" @click.prevent="report_region = 'mt', report_play_style = 'default'" v-if="enabledRegion.indexOf('mt') >= 0">
            MT
          </f7-button>
          <f7-button :active="report_region === 'mb'" @click.prevent="report_region = 'mb', report_play_style = 'default'" v-if="enabledRegion.indexOf('mb') >= 0">
            MB
          </f7-button>
        </f7-segmented>
      </f7-block>
      <f7-block inset class="mt-0 mb-2" v-if="enabledPlaystyle.length >= 2">
        <f7-segmented strong raised v-if="report_region === 'mn'">
          <f7-button :active="report_play_style === 'default'" @click.prevent="report_play_style = 'default', getDetailReport(report_date, report_date_to)" v-if="enabledPlaystyle.indexOf('default') >= 0">
            Sài Gòn
          </f7-button>
          <f7-button :active="report_play_style === 'mn_mtay'" @click.prevent="report_play_style = 'mn_mtay', getDetailReport(report_date, report_date_to)" v-if="enabledPlaystyle.indexOf('mn_mtay') >= 0">
            Miền Tây
          </f7-button>
          <f7-button :active="report_play_style === 'mn_buonme'" @click.prevent="report_play_style = 'mn_buonme', getDetailReport(report_date, report_date_to)" v-if="enabledPlaystyle.indexOf('mn_buonme') >= 0">
            Buôn Mê
          </f7-button>
        </f7-segmented>
        <f7-segmented strong raised v-else-if="report_region === 'mt'">
          <f7-button :active="report_play_style === 'default'" @click.prevent="report_play_style = 'default', getDetailReport(report_date, report_date_to)" v-if="enabledPlaystyle.indexOf('default') >= 0">
            Sài Gòn
          </f7-button>
          <f7-button :active="report_play_style === 'mt_mtay'" @click.prevent="report_play_style = 'mt_mtay', getDetailReport(report_date, report_date_to)" v-if="enabledPlaystyle.indexOf('mt_mtay') >= 0">
            Miền Tây
          </f7-button>
          <f7-button :active="report_play_style === 'mt_buonme'" @click.prevent="report_play_style = 'mt_buonme', getDetailReport(report_date, report_date_to)" v-if="enabledPlaystyle.indexOf('mt_buonme') >= 0">
            Buôn Mê
          </f7-button>
        </f7-segmented>
        <f7-segmented strong raised v-else-if="report_region === 'mb'">
          <f7-button :active="report_play_style === 'default'" @click.prevent="report_play_style = 'default', getDetailReport(report_date, report_date_to)" v-if="enabledPlaystyle.indexOf('default') >= 0">
            Sài Gòn
          </f7-button>
          <f7-button :active="report_play_style === 'mb_mtay'" @click.prevent="report_play_style = 'mb_mtay', getDetailReport(report_date, report_date_to)" v-if="enabledPlaystyle.indexOf('mb_mtay') >= 0">
            Miền Tây
          </f7-button>
          <f7-button :active="report_play_style === 'mb_buonme'" @click.prevent="report_play_style = 'mb_buonme', getDetailReport(report_date, report_date_to)" v-if="enabledPlaystyle.indexOf('mb_buonme') >= 0">
            Buôn Mê
          </f7-button>
          <f7-button :active="report_play_style === 'mb_ngan'" @click.prevent="report_play_style = 'mb_ngan', getDetailReport(report_date, report_date_to)" v-if="enabledPlaystyle.indexOf('mb_ngan') >= 0">
            Nghệ An
          </f7-button>
          <f7-button :active="report_play_style === 'mb_hanoi'" @click.prevent="report_play_style = 'mb_hanoi', getDetailReport(report_date, report_date_to)" v-if="enabledPlaystyle.indexOf('mb_hanoi') >= 0">
            Hà Nội
          </f7-button>
        </f7-segmented>
      </f7-block>
      <template v-if="!_.isEmpty(detail_report_result)">
        <f7-block inset strong class="text-align-center" v-if="detail_report_have_result === 0">
          Không có dữ liệu
        </f7-block>
        <message-detail-summary v-for="(item, idx) in _.orderBy(detail_report_result, o => o.customer.type, ['asc'])" :key="idx" :item="item" :region="report_region" :play-style="report_play_style" :draw-date="report_date_string"></message-detail-summary>
      </template>
    </template>
  </f7-page>
</template>
<script>
import moment from "moment-timezone";
import { mapState } from 'vuex';

import MessageDetailSummary from "@/components/MessageReportSummary";
import MessageRegionSummary from "@/components/MessageRegionReportSummary";
import detail from "@/pages/Message/Detail.vue";

export default {
  components: {
    MessageDetailSummary,
    MessageRegionSummary
  },
  data() {
    return {
      report_date: new Date(),
      report_date_to: new Date(),
      report_region: '',
      report_play_style: '',
      report_result: {},
      detail_report_result: {},
      region_report_result: {},
      tab_active: 'today',
      report_type_tab: 'summary',
      report_date_string: ''
    }
  },
  computed: {
    detail() {
      return detail
    },
    ...mapState(['user_info', 'customers']),
    report_khach_customers(){
      if (this.report_result.length === 0){
        return [];
      }

      let custs = [];

      _.each(this.report_result, function(cust){
        if (cust.customer.type === 1){
          custs.push(cust);
        }
      });

      return custs;
    },
    report_chu_customers() {
      if (this.report_result.length === 0) {
        return [];
      }

      let custs = [];

      _.each(this.report_result, function(cust) {
        if (cust.customer.type === 2) {
          custs.push(cust);
        }
      });

      return custs;
    },
    sum_profit() {
      return this.getSumProfitRegion('mn') + this.getSumProfitRegion('mt') + this.getSumProfitRegion('mb');
    },
    enabledRegion() {
      let regions = [];
      if (!!this.user_info.user_configs.display_mn || !!this.user_info.user_configs.display_mn_mtay || !!this.user_info.user_configs.display_mn_buonme) {
        regions.push('mn');
      }
      if (!!this.user_info.user_configs.display_mt || !!this.user_info.user_configs.display_mt_mtay || !!this.user_info.user_configs.display_mt_buonme) {
        regions.push('mt');
      }
      if (this.user_info.server_region === 'hanoi' || !!this.user_info.user_configs.display_mb || !!this.user_info.user_configs.display_mb_mtay || !!this.user_info.user_configs.display_mb_ngan || !!this.user_info.user_configs.display_mb_buonme || !!this.user_info.user_configs.display_mb_hanoi) {
        regions.push('mb');
      }
      return regions;
    },
    enabledPlaystyle() {
      let playStyles = [];
      if (this.report_region === 'mn') {
        if (!!this.user_info.user_configs.display_mn) {
          playStyles.push('default');
        }
        if (!!this.user_info.user_configs.display_mn_mtay) {
          playStyles.push('mn_mtay');
        }
        if (!!this.user_info.user_configs.display_mn_buonme) {
          playStyles.push('mn_buonme');
        }
      }
      else if (this.report_region === 'mt') {
        if (!!this.user_info.user_configs.display_mt) {
          playStyles.push('default');
        }
        if (!!this.user_info.user_configs.display_mt_mtay) {
          playStyles.push('mt_mtay');
        }
        if (!!this.user_info.user_configs.display_mt_buonme) {
          playStyles.push('mt_buonme');
        }
      }
      else if (this.report_region === 'mb') {
        if (!!this.user_info.user_configs.display_mb) {
          playStyles.push('default');
        }
        if (!!this.user_info.user_configs.display_mb_mtay) {
          playStyles.push('mb_mtay');
        }
        if (!!this.user_info.user_configs.display_mb_buonme) {
          playStyles.push('mb_buonme');
        }
        if (!!this.user_info.user_configs.display_mb_ngan) {
          playStyles.push('mb_ngan');
        }
        if (!!this.user_info.user_configs.display_mb_hanoi || this.user_info.server_region === 'hanoi') {
          playStyles.push('mb_hanoi');
        }
      }

      return playStyles;
    },
    detail_report_have_result() {
      if (!_.isEmpty(this.detail_report_result)) {
        for(let i = 0 ; i < this.detail_report_result.length ; i++){
          if (this.detail_report_result[i].summary.result !== 0) {
            return 1;
          }
        }
      }
      return 0;
    }
  },
  methods: {
    getReport(from_date, to_date) {
      if (moment(from_date).format('YYYY-MM-DD') === moment(to_date).format('YYYY-MM-DD')) {
        this.report_date_string = moment(from_date).format('DD/MM/YYYY');
      }
      else{
        this.report_date_string = moment(from_date).format('DD/MM/YYYY') + ' đến ' + moment(to_date).format('DD/MM/YYYY');
      }

      this.$f7.preloader.show();

      this.$store.dispatch('getReportV2', {
        from_drawdate: moment(from_date).format('YYYY-MM-DD'),
        to_drawdate: moment(to_date).format('YYYY-MM-DD'),
      }).then((data) => {
        this.$f7.preloader.hide();
        this.report_result = data;
      }).catch(() => {
        this.$f7.preloader.hide();
        this.report_result = {};
      });
    },
    getSumProfitRegion(region) {
      let sum = 0;
      _.each(this.report_result, (item) => {
        sum += item.summary[region].result_line_percent;
      });
      return sum;
    },
    getDetailReport(from_date, to_date) {
      if (this.customers.length === 0) {
        return false;
      }

      if (moment(from_date).format('YYYY-MM-DD') === moment(to_date).format('YYYY-MM-DD')) {
        this.report_date_string = moment(from_date).format('DD/MM/YYYY');
      }
      else{
        this.report_date_string = moment(from_date).format('DD/MM/YYYY') + ' đến ' + moment(to_date).format('DD/MM/YYYY');
      }

      this.$f7.preloader.show();

      this.$store.dispatch('getMultiCustomersReport', {
        from_drawdate: moment(from_date).format('YYYY-MM-DD'),
        to_drawdate: moment(to_date).format('YYYY-MM-DD'),
        region: this.report_region,
        play_style: this.report_play_style
      }).then((data) => {
        this.$f7.preloader.hide();
        this.detail_report_result = data;
      }).catch(() => {
        this.$f7.preloader.hide();
        this.detail_report_result = {};
      });
    },
    getRegionReport(from_date, to_date) {
      if (this.customers.length === 0) {
        return false;
      }

      if (moment(from_date).format('YYYY-MM-DD') === moment(to_date).format('YYYY-MM-DD')) {
        this.report_date_string = moment(from_date).format('DD/MM/YYYY');
      }
      else{
        this.report_date_string = moment(from_date).format('DD/MM/YYYY') + ' đến ' + moment(to_date).format('DD/MM/YYYY');
      }

      this.$f7.preloader.show();

      this.$store.dispatch('getRegionSummaryReport', {
        from_drawdate: moment(from_date).format('YYYY-MM-DD'),
        to_drawdate: moment(to_date).format('YYYY-MM-DD'),
        region: this.report_region,
        play_style: this.report_play_style
      }).then((data) => {
        this.$f7.preloader.hide();
        this.region_report_result = data;
      }).catch(() => {
        this.$f7.preloader.hide();
        this.region_report_result = {};
      });
    },
    refreshReport() {
      if (this.report_type_tab === 'summary') {
        this.getReport(this.report_date, this.report_date_to);
      }
      else if (this.report_type_tab === 'detail') {
        this.getDetailReport(this.report_date, this.report_date_to);
      }
      else if (this.report_type_tab === 'region') {
        this.getRegionReport(this.report_date, this.report_date_to);
      }
    }
  },
  watch: {
    report_date() {
      if (this.tab_active === 'today') {
        this.report_date_to = this.report_date;
      }
      else if (this.tab_active === 'custom') {
        this.refreshReport();
      }
    },
    report_date_to() {
      this.refreshReport();
    },
    tab_active() {
      if (this.tab_active === 'today') {
        this.report_date = moment().tz('Asia/Ho_Chi_Minh').format('YYYY-MM-DD');
        this.report_date_to = moment().tz('Asia/Ho_Chi_Minh').format('YYYY-MM-DD');
      }
      else if (this.tab_active === 'this_week') {
        this.report_date = moment().tz('Asia/Ho_Chi_Minh').startOf('isoWeek').format('YYYY-MM-DD');
        this.report_date_to = moment().tz('Asia/Ho_Chi_Minh').endOf('isoWeek').format('YYYY-MM-DD');
      }
      else if (this.tab_active === 'last_week') {
        this.report_date = moment().tz('Asia/Ho_Chi_Minh').subtract(1, 'week').startOf('isoWeek').format('YYYY-MM-DD');
        this.report_date_to = moment().tz('Asia/Ho_Chi_Minh').subtract(1, 'week').endOf('isoWeek').format('YYYY-MM-DD');
      }
    },
    report_type_tab() {
      if (this.report_type_tab === 'detail') {
        if (this.report_region === '') {
          this.report_region = this.enabledRegion[0];
        }
        else{
          this.refreshReport();
        }
      }
      else if (this.report_type_tab === 'region') {
        if (this.report_region === '') {
          this.report_region = this.enabledRegion[0];
        }
        else{
          this.refreshReport();
        }
      }
    },
    report_region() {
      this.report_play_style = this.enabledPlaystyle[0];
      this.refreshReport();
    }
  }
};
</script>
